module.exports = __webpack_public_path__ + "static/media/pro-acc-mgmt-bg.4be97a74.png";